import React from 'react';

import NCSLogoIcon from '../../assets/ncs-logo-icon.svg';
import './styles.css';

const FloatingMenu = ({ data, choosePage, closeMenu }) => {
    if (!data) return <></>;

    const pageInfo = [
        'Início',
        '01 - Todo mundo é muita gente',
        '02 - Primeiros passos digitais',
        '03 - Bang bang digital',
        '04 - Perigos, riscos e danos',
        '05 - Fazer com e não para',
    ];

    

    return (
        <div id='ncs-floating-menu-overlay' onClick={() => closeMenu()}>
            <div id='ncs-floating-menu'>
                {data.map((page, index) => {
                    const maskUrl = index ? (page.icon + '?not-from-cache') : NCSLogoIcon;

                    return (
                        <button key={index} type='button' onClick={() => choosePage(index)}>
                            <div
                                className='ncs-floating-menu-icon'
                                style={{
                                    maskImage: `url(${maskUrl})`,
                                    WebkitMaskImage: `url(${maskUrl})`,
                                }}
                            />
                            <div className='ncs-floating-menu-info'>
                                <span>{pageInfo[index]}</span>
                                <span>{page.island}</span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default FloatingMenu;
